import { BaseStore } from "./baseStore";
export const emptyMapFilterMenu = {
    name: "",
    artccId: "KZNY",
    buttons: [],
};
export const emptyBCG = {
    name: "",
    artccId: "KZNY",
    buttons: [],
};
class GeomapStore extends BaseStore {
    _activeGeomapConfig = null;
    _geomapConfigs = [];
    _geomaps = [];
    _saaGeomaps = [];
    _mapFilterMenus = [];
    _bcgs = [];
    get mapFilterMenus() {
        return this._mapFilterMenus;
    }
    set mapFilterMenus(value) {
        this._mapFilterMenus = value;
    }
    get saaGeomaps() {
        return this._saaGeomaps;
    }
    set saaGeomaps(value) {
        this._saaGeomaps = value;
    }
    get geomaps() {
        return this._geomaps;
    }
    set geomaps(value) {
        this._geomaps = value;
        this.sync();
    }
    get geomapConfigs() {
        return this._geomapConfigs;
    }
    set geomapConfigs(value) {
        this._geomapConfigs = value;
        this.sync();
    }
    get bcgs() {
        return this._bcgs;
    }
    set bcgs(value) {
        this._bcgs = value;
        this.sync();
    }
    get activeGeomapConfig() {
        return this._activeGeomapConfig;
    }
    set activeGeomapConfig(value) {
        this._activeGeomapConfig = value;
        this.sync();
    }
    get activeMapFitlerMenu() {
        return (this.mapFilterMenus.find((menu) => menu.name === this.activeGeomapConfig?.filterMenuName) ??
            emptyMapFilterMenu);
    }
    get activeBCG() {
        return this.bcgs.find((bcg) => bcg.name === this.activeGeomapConfig?.bcgMenuName) ?? emptyBCG;
    }
    state = {
        geomapConfig: this.activeGeomapConfig,
        geomaps: this.geomaps,
        saaGeomaps: this.saaGeomaps,
        mapFilterMenu: this.activeMapFitlerMenu,
        bcg: this.activeBCG,
    };
    computeLatestState() {
        return {
            geomapConfig: this.activeGeomapConfig,
            geomaps: this.geomaps,
            saaGeomaps: this.saaGeomaps,
            mapFilterMenu: this.mapFilterMenus.find((menu) => menu.name === this.activeGeomapConfig?.filterMenuName) ??
                emptyMapFilterMenu,
            bcg: this.bcgs.find((bcg) => bcg.name === this.activeGeomapConfig?.bcgMenuName) ?? emptyBCG,
        };
    }
    constructor() {
        super();
    }
}
export const geomapStore = new GeomapStore();
//# sourceMappingURL=geomapStore.js.map